module.exports = __webpack_public_path__ + "static/media/sy.c425f6f3.svg";